module.exports = __webpack_public_path__ + "static/virajimg-f96af79e9325fbb909cfc6eb5adca49b.jpg";